import logo from './logo.svg';
import search from './search.svg';
import favicon from './favicon2.ico'
import './App.css';
import { useState,useEffect, useRef } from 'react'
import SongCard from './SongCard';
import ReactSearchBox from "react-search-box";

import { Link } from 'react-router-dom'

function Dashboard() {
  const handler = (e) => {
    if (e.matches == false) {
      setXs(true)
    } else {
      setXs(false)
    }
  }
  const [data, setData] = useState([]);
  // suggestions useref
  const suggestions = useRef([]);
  const searchQuery = useRef("")
  const [resultsFound, setResultsFound] = useState(0)
  const [loading, setLoading] = useState(true);
  const [fetching, setFetching] = useState(true);
  const [showSearch, setShowSearch] = useState(false);
  const [xs, setXs] = useState(false);
  const [timeframe, setTimeframe] = useState(localStorage.getItem("timeframe") ? localStorage.getItem("timeframe") : 3);
  const unselectedButtonStyle = "py-2 px-2 sm:px-4 text-xs font-medium text-pink-900 bg-transparent border border-pink-900 hover:bg-pink-900 hover:text-pink-50 focus:z-10 focus:ring-2 focus:ring-pink-500 focus:bg-pink-900 focus:text-white dark:border-white dark:text-white"
  const searchButtonStyle = "py-2 px-0 ml-2 sm:px-4 text-xs font-bold text-pink-900 bg-transparent border border-pink-900 hover:bg-pink-900 hover:text-pink-50 focus:z-10 focus:ring-2 focus:ring-pink-500 focus:bg-pink-900 focus:text-white dark:border-white dark:text-white"
  const selectedButtonStyle = "py-2 px-2 sm:px-4 text-xs font-medium text-pink-50 bg-pink-800 border border-pink-800"
  
  const [hasFetched, setHasFetched] = useState([])
  const [fetchedCache, setFetchedCache] = useState({})
  const [nowPlayingFetched, setNowPlayingFetched] = useState(false)
  const [nowPlayingData, setNowPlayingData] = useState({
    artist: "",
    programme: "",
    song: "",
  })
 
  const refreshNowPlaying = () => {
    fetch('https://api.durianbit.com/k92/nowplaying')
    .then(response => response.json())
    .then(json => {
      setNowPlayingData(json)
      // console.log(json)
      setNowPlayingFetched(true)
    })
  }

  const refreshData = (t) => {
    setFetching(true)
    if (hasFetched.includes(t)) {
      setData(fetchedCache[t])
      localStorage.setItem("timeframe", t)
      setTimeframe(t)
      setLoading(false)
      setFetching(false)
    } else {
      fetch('https://api.durianbit.com/k92/top/days/' + t)
        .then(response => response.json())
        .then(json => {
          // console.log(json)
          setData(json) // should prolly memoise this
          // append t to hasFetched array
          setHasFetched([...hasFetched, t])
          // append t to fetchedCache
          setFetchedCache({...fetchedCache, [t]: json})
          // set timeframe to localstorage
          localStorage.setItem("timeframe", t)
          setTimeframe(t)
          setLoading(false)
          setFetching(false)
        })
    }
  }
  useEffect(() => {
    // get timeframe from localstorage
    let t = localStorage.getItem("timeframe")
    if (t) {
      setTimeframe(t)
    }
    if (window.matchMedia("(min-width: 768px)").matches == false) {
      setXs(true)
    } else {
      setXs(false)
    }
    //run refresh now playing every 20 seconds
    refreshNowPlaying()
    setInterval(() => {
      refreshNowPlaying()
    }, 20000)

    // fetch from url and set to data
    refreshData(timeframe);
    window.matchMedia("(min-width: 768px)").addEventListener('change', handler);
  }, [])
  return (
    <>
                <div className="flex flex-row align-middle">
                  <a href='https://www.kiss92.sg' target="_blank">
                    <img className="mb-3 w-20 h-20" src={favicon}/>
                  </a>
                </div>
                <h4 className="text-left text-2xl md:text-3xl font-bold font-sans text-pink-400">{ loading ? "Loading.." : "Kiss92 Explorer"}</h4>
                <div className="flex flex-col items-start">

                {
                    nowPlayingFetched &&

                    <a href={nowPlayingData.explorer_uri}>
                    <div className="mt-2 mb-2 flex flex-col text-sm font-bold font-sans text-left">
                    <p className="text-pink-400">🎵 Now Playing</p>
                    <p className="text-pink-300">{nowPlayingData.song} by {nowPlayingData.artist}</p>
                    <p className="text-pink-200">on {nowPlayingData.programme}</p>
                    </div>
                    </a>
                  }
                <div className="float-left rounded-md mt-2">
                  <button type="button" className={(timeframe == 3 ? selectedButtonStyle : unselectedButtonStyle) + " rounded-l-lg"} 
                  disabled={timeframe == 3}
                  onClick={() => {
                    if (timeframe != 3) {
                    refreshData(3)
                    }
                  }}
                  >
                  { xs ? "3D" : "3 Days"}
                  </button>
                  <button type="button" className={(timeframe == 7 ? selectedButtonStyle : unselectedButtonStyle) + " border-t border-b"}
                  disabled={timeframe == 7}
                  onClick={() => {
                    if (timeframe != 7) {
                    refreshData(7)
                    }
                  }}
                  >
                  { xs ? "1W" : "1 Week"}
                  </button>

                  <button type="button" className={(timeframe == 14 ? selectedButtonStyle : unselectedButtonStyle) + " border-t border-b"}
                  disabled={timeframe == 14}
                  onClick={() => {
                    if (timeframe != 14) {
                    refreshData(14)
                    }
                  }}
                  >
                  { xs ? "2W" : "2 Weeks"}
                  </button>

                  <button type="button" className={(timeframe == 30 ? selectedButtonStyle : unselectedButtonStyle) + " border-t border-b"}
                  disabled={timeframe == 30}
                  onClick={() => {
                    if (timeframe != 30) {
                    refreshData(30)
                    }
                  }}
                  >
                  { xs ? "1M" : "1 Month"}
                  </button>
                  <button type="button" className={(timeframe == 90 ? selectedButtonStyle : unselectedButtonStyle) + " rounded-r-md"}
                  disabled={timeframe == 90}
                  onClick={() => {
                    if (timeframe != 90) {
                    refreshData(90)
                    }
                  }}
                  >
                  { xs ? "3M" : "3 Months"}
                  </button>
                </div>
                
                <div className="rounded-md mt-2">
                  <div className=" flex flex-row items-center">
                  {/* <h5 className="text-left text-sm md:text-md font-bold font-sans text-pink-400">Search</h5> */}
                  
                  <ReactSearchBox
                    placeholder="Search All Songs"
                    value=""
                    data={[]}
                    onChange={(e) => {
                        if (e.length > 0) {
                        // convert string to url params
                        let params = new URLSearchParams();
                        params.append("q", e);
                        // fetch from url and set to data
                        setShowSearch(false)
                        setShowSearch(true)
                        setFetching(true)
                        fetch('https://api.durianbit.com/k92/search?' + params)
                        .then(response => response.json())
                        .then(json => {
                          // console.log(json)
                          setResultsFound(-1)
                          searchQuery.current = e
                          suggestions.current = json.results
                          setResultsFound(json.resultsCount)
                          setShowSearch(true)
                          // if (suggestions.current.length > 0) {
                          //   setShowSearch(true)
                          // } else {
                          //   setShowSearch(false)
                          // }
                        })
                        setFetching(false)
                      } else {
                        setShowSearch(false)
                      }

                    }}
                  />
                    
                  </div>
                </div>
                </div>
                
                {/* <br/> */}
                <p className="mt-6 text-lg md:text-xl text-pink-300 text-left">{ showSearch ? (resultsFound + " Search Result" + (resultsFound == 1 ? "" : "s") + " Found for '" + searchQuery.current + "'") : fetching ? "Fetching data.." : "Viewing most played songs in the past" + (
                  timeframe == 3 ? " 3 days" :
                  timeframe == 7 ? " 1 week" :
                  timeframe == 14 ? " 2 weeks" :
                  timeframe == 30 ? " 1 month" :
                  timeframe == 90 ? " 3 months" :
                  "..."
                )
                }
                </p>
                {/* <p className="mt-4 text-lg md:text-xl text-pink-300 text-left">From this website, you can view song statistics from Singapore's Kiss92 Radio Station.</p> */}
                {
                  showSearch &&
                  <div className="flex flex-col items-start">
                    <button className='px-2 py-1 mt-2 bg-pink-300 text-sm rounded-md' onClick={() => {
                      setShowSearch(false)
                      searchQuery.current = ""
                      suggestions.current = []
                    }}>
                      Close Search Results
                    </button>
                  </div>
                }
                { loading ? 
                  <div className="flex justify-center mt-4">
                    <div className="spinner-border text-pink-400" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                  :
                  showSearch ? 
                  <div className="flex flex-col items-start mt-6">
                    { suggestions.current.map((s, i) => {
                      return (
                        <div className="flex flex-row items-left mt-6" key={i}>
                          <div className="flex flex-col items-left text-md text-left">
                            <Link to={"/s/" + s.key}>
                            <a className='text-pink-300 hover:text-pink-500 hover:underline font-semibold'>{s.value}</a>
                            </Link>
                            </div>
                            </div>
                      )})
                    }
                  </div>
                  :
                  data.data.map((item, key)=> {
                    return (
                        <SongCard key={key} data={item} rank={key+1}/>
                    )
                  })  
                }
                </>
  );
}

export default Dashboard;
